import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M25 12C25 7.02944 20.9705 3 16 3C11.0294 3 6.99999 7.02944 6.99999 12C6.99999 15.2833 8.75811 18.1559 11.3834 19.7276C7.90068 20.8541 4.89273 23.2358 3.00773 26.4986C2.73145 26.9768 2.89515 27.5884 3.37336 27.8647C3.85157 28.141 4.46321 27.9773 4.73949 27.4991C7.06305 23.4772 11.3553 21 16.0001 21L16.3725 21.0053C20.8734 21.1338 24.9993 23.5851 27.2606 27.4993C27.5369 27.9775 28.1485 28.1412 28.6267 27.865C29.1049 27.5887 29.2687 26.9771 28.9924 26.4988C27.1073 23.2358 24.0991 20.8539 20.6157 19.7279C23.2419 18.1559 25 15.2833 25 12ZM16.029 18.9999L15.9711 19L15.7593 18.9959C12.0048 18.8691 8.99999 15.7855 8.99999 12C8.99999 8.13401 12.134 5 16 5C19.866 5 23 8.13401 23 12C23 15.8563 19.8817 18.9843 16.029 18.9999Z"
	})
});
export default SvgUser;
